import { render, staticRenderFns } from "./DirectorDividendsPrevious.vue?vue&type=template&id=e900904c"
import script from "./DirectorDividendsPrevious.vue?vue&type=script&lang=js"
export * from "./DirectorDividendsPrevious.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports